import React, { FC } from "react";
import MainHeader from "@components-monorepo/components/main-header/main-header-ssr";
import { Addon, StoreMetadata } from "@commons-monorepo/index";
import { CategoriesResponse } from "~/common/props/category";
import { avatarProfile } from "~/assets/svg";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { useOutletContext } from "react-router-dom";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useAuth } from "~/common/contexts/auth.provider";
import { useTranslation } from "react-i18next";

type Props = {
  storeMetadata: StoreMetadata;
  categoriesResponse: CategoriesResponse;
  partnerWithPrivateDomain: boolean;
  userAddons: Addon<any>[];
};

export const Header: FC<Props> = ({
  storeMetadata,
  categoriesResponse,
  partnerWithPrivateDomain,
  userAddons,
}) => {
  const { t } = useTranslation();
  const { theme, storeInformationInView } = useGlobalStyles();
  const { isMobile } = useOutletContext<any>();
  const { goToCheckout, cartProducts } = useCart();
  const { user } = useAuth();
  return (
    <MainHeader
      categories={categoriesResponse.categories}
      hasOffers={categoriesResponse.hasOffers}
      hasServices={categoriesResponse.hasServices}
      hasWholesale={categoriesResponse.hasWholesale}
      partnerId={storeMetadata?.userNetwork?.urlSummer}
      ownerId={storeMetadata?.ownerId}
      isPrime={storeMetadata?.primeId !== null}
      theme={theme}
      partnerWithPrivateDomain={partnerWithPrivateDomain}
      data={{
        userAddons,
        storeMetadata,
        avatarProfile,
        categories: categoriesResponse?.categories,
        isMobile: isMobile,
        cartProducts: cartProducts,
        user,
      }}
      isPortraitInView={storeInformationInView}
      t={t}
      goToCheckout={goToCheckout}
    />
  );
};
